import Icon from '../components/Icon.vue'

Icon.register({
  tablet: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V48C448 21.5 426.5 0 400 0zM224 480C206.3 480 192 465.7 192 448S206.3 416 224 416 256 430.3 256 448 241.7 480 224 480z'
      }
    ]
  }
})
